import { Component, Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { OrderList } from '../../../order/components/order-list/component';
import { IOrderListConfig } from '../../../order/interfaces/order-list-config';
import { IProduct } from '../../interfaces/product';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'product-order-list-dialog',
    templateUrl: 'component.html',
    styleUrls: [
        '../../../order/components/order-list/component.scss',
        'component.scss',
    ],
    standalone: false
})
@Injectable()
export class ProductOrderList extends OrderList {
  public Item: IProduct;
  protected colunms = [
    {
      name: 'name',
      displayName: 'Name',
      width: '*',
    },
    {
      name: 'employee_number',
      displayName: 'Employee Number',
      width: 'auto',
    },
    {
      name: 'phone',
      displayName: 'Phone',
      width: 'auto',
    },
    {
      name: 'total_tickets',
      displayName: 'Total Tickets',
      width: 'auto',
    },
    {
      name: 'cohort',
      displayName: 'Cohort',
      width: 'auto',
    },
  ];
  public displayedColumns = [
    'status',
    'name',
    'email',
    'total_tickets',
    'notes',
    'actions',
  ];

  protected getFileName(): string {
    const { title: listingTitle } = this;
    const { title: productTitle } = this.Item;

    return `${listingTitle}-${productTitle}`;
  }

  public constructor(
    protected Dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) protected config: IOrderListConfig,
    Auth: AuthService
  ) {
    super(Auth);

    this.DataSource = config.DataSource;
    this.Item = config.Item as IProduct;
    this.title = config.title;
  }
}
